import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const FeatureGrid = () => {
  const features = [
    {
      title: "Donate",
      description:
        "Every gift, big or small helps build strength, stability and independence for families struggling to afford a decent home.",
      buttonText: "Donate",
      color: "var(--hhb-green)",
      buttonColor: "var(--hhb-green)",
      icon: "🎁",
      link: "/donate",
    },
    {
      title: "Volunteer",
      description:
        "With Habitat for Humanity, you have the opportunity to build in your community and also in communities around the world.",
      buttonText: "Volunteer",
      color: "var(--hhb-orange)",
      buttonColor: "var(--hhb-orange)",
      icon: "🔨",
      link: "/get-involved",
    },
    {
      title: "Programs",
      description:
        "You can partner with Habitat for Humanity to BUILD or IMPROVE a place you can call home.",
      buttonText: "Learn More",
      color: "var(--hhb-primary)",
      buttonColor: "var(--hhb-primary)",
      icon: "🏠",
      link: "/how-to-apply",
    },
    {
      title: "Shop ReStore",
      description:
        "ReStores sell new and gently used furniture, appliances, building materials, and more to the public at a fraction of the retail price.",
      buttonText: "Find a ReStore",
      color: "var(--hhb-darkblue)",
      buttonColor: "var(--hhb-darkblue)",
      icon: "🛒",
      link: "/restore",
    },
  ];

  return (
    <GridContainer>
      {features.map((feature, index) => (
        <FeatureCard
          key={index}
          color={feature.color}
          aria-labelledby={`feature-title-${index}`}
          aria-describedby={`feature-description-${index}`}
        >
          <Icon>{feature.icon}</Icon>
          <FeatureTitle id={`feature-title-${index}`}>
            {feature.title}
          </FeatureTitle>
          <FeatureDescription id={`feature-description-${index}`}>
            {feature.description}
          </FeatureDescription>
          <FeatureButton to={feature.link} color={feature.buttonColor}>
            {feature.buttonText}
          </FeatureButton>
        </FeatureCard>
      ))}
    </GridContainer>
  );
};

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 834px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  background-color: ${({ color }) => color};
  color: #fff;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`;

const Icon = styled.div`
  font-size: 40px;
  color: white;
`;

const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 10px;
`;

const FeatureDescription = styled.p`
  flex: 1;
  font-size: 1rem;
  margin-bottom: 20px;
`;

const FeatureButton = styled(Link)`
  background-color: #fff;
  color: ${({ color }) => color};
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 4px;
  text-decoration: none;

  &:hover {
    background-color: ${({ color }) => color};
    color: #fff;
    border: 1px solid #fff;
  }
`;

export default FeatureGrid;
